import React from 'react';
import type {MessageQueueStatus} from 'services/healthcheck/types';
import {useLocalization} from 'localization';
import {getQueueHealth} from 'services/healthcheck';
import {FlexBox} from 'components/layout';
import {Spacer} from 'components/spacer';
import {HealthIndicator} from './HealthIndicator';
import {HealthSubtitle} from './HealthSubtitle';

type Props = {
  data: MessageQueueStatus;
};

export const QueueHealth: React.FC<Props> = ({data}) => {
  const {t, tLoose} = useLocalization();
  const status = getQueueHealth(data);

  const topic = tLoose(`system.queue.${data.topic}.title`);
  const length = t('system.queue.length', {count: data.length});
  return (
    <FlexBox horizontal center left>
      <HealthIndicator status={status} />
      <Spacer width={1} />
      <HealthSubtitle title={`${topic}, ${length}`} />
    </FlexBox>
  );
};
